[
    {
        "header": {
            "EN": "Word Game",
            "RU": "Игра 'Wordle'",
            "ES": "Juego Wordle"
        },
        "languageModalHeader": {
            "EN": "Select language",
            "RU": "Выбор языка",
            "ES": "Seleccione el idioma"
        },
        "languagesList": [
            { "label": "English", "value": "EN" },
            { "label": "Русский", "value": "RU" },
            { "label": "Espanol", "value": "ES" }
        ],
        "keyboard": {
            "EN": [
                ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
                ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
                ["DELETE", "Z", "X", "C", "V", "B", "N", "M", "ENTER"]
            ],
            "RU": [
                ["Й", "Ц", "У", "К", "Е", "Н", "Г", "Ш", "Щ", "З", "Х", "Ъ"],
                ["Ф", "Ы", "В", "А", "П", "Р", "О", "Л", "Д", "Ж", "Э"],
                ["DELETE", "Я", "Ч", "С", "М", "И", "Т", "Ь", "Б", "Ю", "ENTER"]
            ],
            "ES": [
                ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
                ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ñ"],
                ["DELETE", "Z", "X", "C", "V", "B", "N", "M", "ENTER"]
            ]
        },
        "allLetters": {
            "EN": [
                "Q",
                "W",
                "E",
                "R",
                "T",
                "Y",
                "U",
                "I",
                "O",
                "P",
                "A",
                "S",
                "D",
                "F",
                "G",
                "H",
                "J",
                "K",
                "L",
                "DELETE",
                "BACKSPACE",
                "Z",
                "X",
                "C",
                "V",
                "B",
                "N",
                "M",
                "ENTER"
            ],
            "RU": [
                "Й",
                "Ц",
                "У",
                "К",
                "Е",
                "Н",
                "Г",
                "Ш",
                "Щ",
                "З",
                "Х",
                "Ъ",
                "Ф",
                "Ы",
                "В",
                "А",
                "П",
                "Р",
                "О",
                "Л",
                "Д",
                "Ж",
                "Э",
                "DELETE",
                "BACKSPACE",
                "Я",
                "Ч",
                "С",
                "М",
                "И",
                "Т",
                "Ь",
                "Б",
                "Ю",
                "ENTER"
            ],
            "ES": [
                "Q",
                "W",
                "E",
                "R",
                "T",
                "Y",
                "U",
                "I",
                "O",
                "P",
                "A",
                "S",
                "D",
                "F",
                "G",
                "H",
                "J",
                "K",
                "L",
                "Ñ",
                "DELETE",
                "BACKSPACE",
                "Z",
                "X",
                "C",
                "V",
                "B",
                "N",
                "M",
                "ENTER"
            ]
        },
        "tooShortNotification": {
            "EN": "The word is too short",
            "RU": "Слово слишком короткое",
            "ES": "Una palabra demasiado corta"
        },
        "wordDoesntExistNotification": {
            "EN": "The word wasn't found",
            "RU": "Данное слово не найдено",
            "ES": "Palabra no encontrada"
        },
        "winBanner": {
            "header": {
                "EN": "You won!",
                "RU": "Победа!",
                "ES": "¡Ganaste!"
            }
        },
        "loseBanner": {
            "header": {
                "EN": "You lost!",
                "RU": "Поражение!",
                "ES": "¡Perdiste!"
            },
            "correctWordText": {
                "EN": "The correct answer was:",
                "RU": "Правильный ответ:",
                "ES": "La respuesta fue:"
            }
        },
        "startNewGameButton": {
            "EN": "New game",
            "RU": "Новая игра",
            "ES": "Reiniciar"
        },
        "statistics": {
            "header": {
                "EN": "Statistics",
                "RU": "Статистика",
                "ES": "Estadísticas"
            },
            "gamesPlayed": {
                "EN": "🕹️ Games Played: ",
                "RU": "🕹️ Всего сыграно игр: ",
                "ES": "🕹️ Juegos Jugados: "
            },
            "gamesWon": {
                "EN": "🏆 Games won: ",
                "RU": "🏆 Выиграно игр: ",
                "ES": "🏆 Juegos Ganados: "
            },
            "percentOfVictories": {
                "EN": "📈 % of Wins: ",
                "RU": "📈 % Побед: ",
                "ES": "📈 Victorias (%): "
            },

            "streak": {
                "EN": "🔥 Streak: ",
                "RU": "🔥 Серия: ",
                "ES": "🔥 Racha: "
            }
        }
    }
]
